(() => {
  'use strict';

  const SELECTORS = {
    root: '[data-quote-upload-form]',
    form: '[data-quote-form]',
    steps: '[data-quote-steps]',
    stepIndicator: '[data-quote-step-indicator]',
    stepNumber: '[data-step-number]',
    panel: '[data-step-panel]',
    dropzone: '[data-quote-dropzone]',
    fileInput: '[data-quote-file-input]',
    fileTrigger: '[data-quote-file-trigger]',
    uploads: '[data-quote-uploads]',
    thumbs: '[data-quote-thumbs]',
    step1Continue: '[data-step1-continue]',
    step2Back: '[data-step2-back]',
    step2Submit: '[data-step2-submit]',
    shippingType: '[data-shipping-type]',
  };

  let uid = 0;
  const nextId = () => `qu-${Date.now()}-${uid++}`;

  const closeIconSvg =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  // Neutral placeholder thumbnail, used only inside the theme editor so
  // merchants can click through step 2 without uploading a real file.
  const DESIGN_MODE_PLACEHOLDER_IMAGE =
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect width="80" height="80" fill="#EDE9FE"/><path d="M20 54l12-14 9 10 8-9 11 13H20z" fill="#643DFC" fill-opacity="0.55"/><circle cx="28" cy="26" r="6" fill="#643DFC" fill-opacity="0.55"/></svg>'
    );

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getState($root) {
    let state = $root.data('quoteUploadState');
    if (!state) {
      state = {
        currentStep: 1,
        uploads: [], // { localId, url, status: 'uploading'|'done'|'error' }
      };
      $root.data('quoteUploadState', state);
    }
    return state;
  }

  /* ---------------------------------------------------------------------
   * Step tracker — two steps, freely clickable in both directions
   * ------------------------------------------------------------------- */

  function updateStepTracker($root) {
    const state = getState($root);
    $root.find(SELECTORS.stepIndicator).each(function () {
      const $step = $(this);
      const index = parseInt($step.attr('data-quote-step-indicator'), 10);
      const $circle = $step.find(SELECTORS.stepNumber);

      $step.removeClass('is-active is-done');

      if (index < state.currentStep) {
        $step.addClass('is-done');
      } else if (index === state.currentStep) {
        $step.addClass('is-active');
      }
      // The number always stays visible — only color/fill indicate progress.
      $circle.text(index);
    });
  }

  function showStep($root, step) {
    const state = getState($root);
    state.currentStep = step;

    $root.find(SELECTORS.panel).each(function () {
      const $panel = $(this);
      const panelStep = parseInt($panel.attr('data-step-panel'), 10);
      if (panelStep === step) $panel.removeAttr('hidden');
      else $panel.attr('hidden', 'hidden');
    });

    updateStepTracker($root);
  }

  function goToStep($root, step) {
    showStep($root, step);
    const top = $root.get(0).getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  /* ---------------------------------------------------------------------
   * Upload — optional, multiple files at once, at the end of step 1
   * ------------------------------------------------------------------- */

  function renumberThumbs($root) {
    $root.find(SELECTORS.thumbs).find('.quote-upload-form__thumb').each(function (index) {
      $(this).find('.quote-upload-form__thumb-badge').text(index + 1);
    });
  }

  function syncUploadState($root) {
    const state = getState($root);
    const $uploads = $root.find(SELECTORS.uploads);
    const $step1Continue = $root.find(SELECTORS.step1Continue);

    if (state.uploads.length > 0) $uploads.removeAttr('hidden');
    else $uploads.attr('hidden', 'hidden');

    // Upload is optional, but Continue is blocked while any file is still
    // uploading so we never advance with a missing/partial S3 url.
    const uploading = state.uploads.some((item) => item.status === 'uploading');
    $step1Continue.attr('aria-disabled', uploading ? 'true' : 'false');
  }

  function addThumbnail($root, localId, dataUrl) {
    const state = getState($root);
    state.uploads.push({ localId, url: null, status: 'uploading' });

    const $thumbs = $root.find(SELECTORS.thumbs);
    const $thumb = $(`
      <div class="quote-upload-form__thumb is-uploading" data-thumb-id="${localId}">
        <img src="${dataUrl}" alt="">
        <span class="quote-upload-form__thumb-badge"></span>
        <button type="button" class="quote-upload-form__thumb-remove" aria-label="Remove">${closeIconSvg}</button>
      </div>
    `);

    $thumb.find('.quote-upload-form__thumb-remove').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      removeThumbnail($root, localId);
    });

    $thumbs.find('.quote-upload-form__add-more').before($thumb);
    renumberThumbs($root);
    syncUploadState($root);
  }

  function markThumbnailDone($root, localId, url) {
    const state = getState($root);
    const item = state.uploads.find((i) => i.localId === localId);
    if (item) {
      item.status = 'done';
      item.url = url;
    }
    $root.find(`[data-thumb-id="${localId}"]`).removeClass('is-uploading');
    syncUploadState($root);
  }

  function markThumbnailError($root, localId) {
    const state = getState($root);
    const item = state.uploads.find((i) => i.localId === localId);
    if (item) item.status = 'error';
    $root.find(`[data-thumb-id="${localId}"]`).removeClass('is-uploading').addClass('has-error');
    syncUploadState($root);
  }

  function removeThumbnail($root, localId) {
    const state = getState($root);
    state.uploads = state.uploads.filter((i) => i.localId !== localId);
    $root.find(`[data-thumb-id="${localId}"]`).remove();
    renumberThumbs($root);
    syncUploadState($root);
  }

  // Theme editor only: seed a placeholder "uploaded design" so the merchant
  // can immediately click through to step 2 to edit its content, without
  // needing to actually upload a file first.
  function seedDesignModeUpload($root) {
    if (!isDesignMode()) return;
    const state = getState($root);
    if (state.uploads.length > 0) return;

    const localId = nextId();
    addThumbnail($root, localId, DESIGN_MODE_PLACEHOLDER_IMAGE);
    markThumbnailDone($root, localId, DESIGN_MODE_PLACEHOLDER_IMAGE);
  }

  function readAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e?.target?.result || '');
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function processOneFile($root, file, target) {
    const dataUrl = await readAsDataUrl(file);
    if (!dataUrl) return;

    const localId = nextId();
    addThumbnail($root, localId, dataUrl);

    if (window.SaveToS3 && typeof window.SaveToS3.saveImg === 'function') {
      window.SaveToS3.saveImg(dataUrl, file.type, { quoteLocalId: localId, quoteTarget: target });
    } else {
      markThumbnailDone($root, localId, dataUrl);
    }
  }

  function processFiles($root, fileList) {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    const target = String($root.attr('data-upload-target') || '').trim();
    files.forEach((file) => {
      processOneFile($root, file, target).catch((err) => {
        console.error('[QuoteUploadForm] file processing failed', err);
      });
    });
  }

  function bindDropzone($root) {
    const $dropzone = $root.find(SELECTORS.dropzone);
    const $input = $root.find(SELECTORS.fileInput);
    if (!$dropzone.length || !$input.length) return;

    $input.on('change', function () {
      processFiles($root, this.files);
      this.value = '';
    });

    $root.find(SELECTORS.fileTrigger).on('click', (e) => {
      e.preventDefault();
      $input.trigger('click');
    });

    $dropzone.on('click', (e) => {
      if ($(e.target).closest(`${SELECTORS.fileTrigger}, ${SELECTORS.fileInput}`).length) return;
      $input.trigger('click');
    });

    $dropzone.on('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if ($(e.target).closest(`${SELECTORS.fileTrigger}, ${SELECTORS.fileInput}`).length) return;
      e.preventDefault();
      $input.trigger('click');
    });

    $dropzone.on('dragover', (e) => {
      e.preventDefault();
      $dropzone.addClass('is-dragover');
    });

    $dropzone.on('dragleave', (e) => {
      e.preventDefault();
      $dropzone.removeClass('is-dragover');
    });

    $dropzone.on('drop', (e) => {
      e.preventDefault();
      $dropzone.removeClass('is-dragover');
      processFiles($root, e.originalEvent?.dataTransfer?.files);
    });
  }

  /* ---------------------------------------------------------------------
   * Occasion picker (single-select)
   * ------------------------------------------------------------------- */

  function bindOccasionPicker($root) {
    $root.find('[data-occasion-option]').on('click', function () {
      $root.find('[data-occasion-option]').removeClass('is-selected');
      $(this).addClass('is-selected');
    });
  }

  /* ---------------------------------------------------------------------
   * Step navigation buttons
   * ------------------------------------------------------------------- */

  function bindStepButtons($root) {
    $root.find(SELECTORS.step1Continue).on('click', function () {
      if ($(this).attr('aria-disabled') === 'true') return;
      goToStep($root, 2);
    });

    $root.find(SELECTORS.step2Back).on('click', () => {
      goToStep($root, 1);
    });

    // Step circles always switch freely between the two steps (no
    // validation gate), similar to jumping between steps in the editor.
    $root.find(SELECTORS.stepIndicator).on('click', function () {
      const step = parseInt($(this).attr('data-quote-step-indicator'), 10);
      if (!step) return;
      if (isDesignMode()) seedDesignModeUpload($root);
      goToStep($root, step);
    });
  }

  /* ---------------------------------------------------------------------
   * Step 2 — contact info + submit
   * ------------------------------------------------------------------- */

  function collectProjectDetails($root) {
    const data = {};
    $root.find(`${SELECTORS.panel}[data-step-panel="1"] [data-field]`).each(function () {
      const $field = $(this);
      data[$field.attr('data-field')] = $field.val();
    });
    const $selectedOccasion = $root.find('[data-occasion-option].is-selected');
    data.occasion = $selectedOccasion.length ? $selectedOccasion.attr('data-value') : '';
    return data;
  }

  function collectContactData($root) {
    const data = {};
    $root.find(`${SELECTORS.panel}[data-step-panel="2"] [data-field]`).each(function () {
      const $field = $(this);
      data[$field.attr('data-field')] = $field.val();
    });
    const $shippingChecked = $root.find(`${SELECTORS.shippingType} input:checked`);
    data.shippingType = $shippingChecked.length ? $shippingChecked.val() : '';
    return data;
  }

  function collectDesignUrls($root) {
    const state = getState($root);
    return state.uploads.filter((item) => item.status === 'done' && item.url).map((item) => item.url);
  }

  const API_BASE_URL = 'https://aav-services.com/api/shop';
  const QUOTE_FORM_ID = 2;

  function buildApiPayload($root) {
    const contact = collectContactData($root);
    return {
      formId: QUOTE_FORM_ID,
      email: contact.email || '',
      formData: {
        projectDetails: collectProjectDetails($root),
        designUrls: collectDesignUrls($root),
        contact,
      },
    };
  }

  function setSubmitLoading($root, isLoading) {
    const $submit = $root.find(SELECTORS.step2Submit);
    $submit.prop('disabled', isLoading).attr('aria-busy', isLoading ? 'true' : 'false');
    $submit.find('span').text(isLoading ? 'Sending…' : $submit.attr('data-default-label') || 'Submit your request');
  }

  function showSubmitError($root, message) {
    let $error = $root.find('[data-submit-error]');
    if (!$error.length) {
      $error = $('<p class="quote-upload-form__error" data-submit-error></p>');
      $root.find(SELECTORS.step2Submit).closest('.quote-upload-form__step3-footer').before($error);
    }
    $error.text(message).removeAttr('hidden');
  }

  function hideSubmitError($root) {
    $root.find('[data-submit-error]').attr('hidden', 'hidden');
  }

  function showSuccessPanel($root) {
    $root.find(SELECTORS.steps).attr('hidden', 'hidden');
    $root.find('.quote-upload-form__divider').attr('hidden', 'hidden');
    $root.find(SELECTORS.panel).attr('hidden', 'hidden');
    $root.find('[data-success-panel]').removeAttr('hidden');
  }

  function bindStep2($root) {
    bindOccasionPicker($root);

    const $submit = $root.find(SELECTORS.step2Submit);
    $submit.attr('data-default-label', $submit.find('span').text());

    $submit.on('click', () => {
      const $form = $root.find(SELECTORS.form).get(0);
      if ($form && typeof $form.reportValidity === 'function' && !$form.reportValidity()) {
        return;
      }

      hideSubmitError($root);
      setSubmitLoading($root, true);

      const payload = buildApiPayload($root);

      fetch(`${API_BASE_URL}/forms/customer-form`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            return response
              .json()
              .catch(() => ({}))
              .then((body) => {
                throw new Error(body.message || `Request failed (${response.status})`);
              });
          }
          return response.json();
        })
        .then((data) => {
          $(document).trigger('quoteForm:submitted', [{ payload, response: data, root: $root.get(0) }]);
          showSuccessPanel($root);
        })
        .catch((error) => {
          console.error('[QuoteUploadForm] submit failed', error);
          showSubmitError($root, 'Something went wrong. Please try again or contact us directly.');
          $(document).trigger('quoteForm:error', [{ payload, error, root: $root.get(0) }]);
        })
        .finally(() => {
          setSubmitLoading($root, false);
        });
    });
  }

  /* ---------------------------------------------------------------------
   * Init
   * ------------------------------------------------------------------- */

  // Binds every not-yet-bound root on the page. Safe to call repeatedly —
  // e.g. Shopify re-renders a section's HTML in the theme editor whenever
  // a setting changes, so this re-runs on `shopify:section:load` too.
  function bindRoots() {
    $(SELECTORS.root).each((_, el) => {
      const $root = $(el);
      if ($root.data('quoteUploadBound')) return;
      $root.data('quoteUploadBound', true);

      bindDropzone($root);
      bindStepButtons($root);
      bindStep2($root);
      syncUploadState($root);
      showStep($root, 1);
      seedDesignModeUpload($root);
    });
  }

  // Document-level listeners only need to be registered once per page,
  // regardless of how many times sections reload in the editor.
  function bindGlobalHandlers() {
    if (window.__quoteUploadFormGlobalBound) return;
    window.__quoteUploadFormGlobalBound = true;

    $(document).on('quoteForm:submitted', () => {
      if (typeof window.fbq !== 'function') return;
      window.fbq('track', 'Lead', {
        content_name: 'Wholesale Quote Form',
      });
    });

    $(document).on('saveToS3:success', (e, eventData) => {
      const data = eventData || {};
      if (!data.quoteLocalId) return;
      const $root = $(`${SELECTORS.root}[data-upload-target="${data.quoteTarget}"]`).first();
      if (!$root.length) return;
      const url = data.url || data.response?.url || null;
      markThumbnailDone($root, data.quoteLocalId, url);
    });

    $(document).on('saveToS3:error', (e, errorData) => {
      const data = errorData || {};
      if (!data.quoteLocalId) return;
      const $root = $(`${SELECTORS.root}[data-upload-target="${data.quoteTarget}"]`).first();
      if (!$root.length) return;
      markThumbnailError($root, data.quoteLocalId);
    });

    // Fired by the Shopify theme editor after it re-renders a section's
    // markup (e.g. after any setting change) — pick up the fresh DOM.
    $(document).on('shopify:section:load', () => bindRoots());
  }

  $(() => {
    bindGlobalHandlers();
    bindRoots();
  });
})();
